export default "__VITE_ASSET__23cfd1ec__"